import { render, staticRenderFns } from "./FacadeWidth.vue?vue&type=template&id=3e89a53c&"
import script from "./FacadeWidth.vue?vue&type=script&lang=ts&"
export * from "./FacadeWidth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports